/**
 * Module d'ajout au panier AJAX pour les pages collection
 * Ce script gère les boutons "add-to-cart" spécifiques aux pages collection de Shopify.
 */
(function() {
  // Configuration
  const config = {
    addToCartSelector: 'a.add-to-cart, button[id^="PCAdd"]',
    cartCountSelector: '#CartCount, .site-header__cart-count[data-cart-render="item_count"]',
    specialPromoModalSelector: '.promo-popup-modal',
    modalSelector: '.popup-basket-notification-modal',
    notificationDuration: 5000,
    promoPopupDuration: 15000,
    specialPromoVariantIds: [
     '44672944308490', // Pack console verte avec 2 livres (3+)
     '44672949289226'  // Pack console verte avec 2 livres (5+)
    ]
  };

  // Fonctions utilitaires
  const utils = {
    /**
     * Met à jour le compteur d'articles dans le panier
     * @param {number} count - Nombre d'articles à ajouter au compteur actuel
     */
    updateCartCount: function(count) {
      const cartCoundElem = document.getElementById("CartCount");
      if(cartCoundElem){
        const currentCount = parseInt(cartCoundElem?.textContent || "0");
        cartCoundElem.textContent = currentCount + count 
      }
    },

    /**
     * Affiche la notification d'ajout au panier
     */
    showNotification: function() {
      const modal = document.querySelector(config.modalSelector);
      console.log(modal);
      if (!modal) return;
    
      const isEnglish = window.Shopify.locale === "en";
      
      modal.classList.add('active');
      
      const closeButton = modal.querySelector('.popup-basket-notification-close');
      if (closeButton) {
        // Supprimer les anciens écouteurs pour éviter les duplications
        const newCloseButton = closeButton.cloneNode(true);
        closeButton.parentNode.replaceChild(newCloseButton, closeButton);
        
        newCloseButton.addEventListener('click', () => {
          modal.classList.remove('active');
        });
      }
      
      // Fermer automatiquement après la durée configurée
      setTimeout(() => {
        modal.classList.remove('active');
      }, config.notificationDuration);
      
      // Mettre à jour l'URL du bouton "Voir le panier" en fonction de la langue
      const cartButton = modal.querySelector('.popup-basket-notification-button');
      if (cartButton) {
        cartButton.href = isEnglish ? '/en/cart' : '/cart';
      }
    },

    /**
     * Affiche la popup promotionnelle spéciale
     */
    showPromoPopup: function() {
      const modal = document.querySelector(config.specialPromoModalSelector);
      if (!modal) return;
    
      const isEnglish = window.Shopify.locale === "en";
      
      modal.classList.add('popup-promo-active');
      
      const closeButton = modal.querySelector('.promo-popup-close');
      if (closeButton) {
        // Supprimer les anciens écouteurs pour éviter les duplications
        const newCloseButton = closeButton.cloneNode(true);
        closeButton.parentNode.replaceChild(newCloseButton, closeButton);
        
        newCloseButton.addEventListener('click', () => {
          modal.classList.remove('popup-promo-active');
        });
      }
      
      // Fermer automatiquement après la durée configurée
      //setTimeout(() => {
      //  modal.classList.remove('popup-promo-active');
      // }, config.promoPopupDuration);
      
      // Mettre à jour l'URL du bouton "Voir le panier" en fonction de la langue
      const cartButton = modal.querySelector('.voir-mon-panier');
      if (cartButton) {
        cartButton.href = isEnglish ? '/en/cart' : '/cart';
      }
    },

    /**
     * Vérifie si un variant ID fait partie de la liste des produits spéciaux
     * @param {string} variantId - ID de la variante à vérifier
     * @returns {boolean} - true si le variant est spécial, false sinon
     */
    isSpecialPromoVariant: function(variantId) {
      return config.specialPromoVariantIds.includes(variantId);
    },

    /**
     * Ajoute un article au panier via AJAX
     * @param {string} variantId - ID de la variante à ajouter
     * @param {number} quantity - Quantité à ajouter
     * @returns {Promise} - Promise résolue avec les données de la réponse
     */
    addToCart: function(variantId, quantity) {
      let formData = {
       'items': [{
        'id': variantId,
        'quantity': quantity
        }]
      };
      
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erreur réseau lors de l\'ajout au panier');
        }
        return response.json();
      });
    }
  };


  /**
   * Initialise le module d'ajout au panier AJAX
   */
  function init() {
    document.addEventListener('click', function(event) {
      const addToCartBtn = event.target.closest(config.addToCartSelector);
      if (!addToCartBtn) return;
      
      event.preventDefault();
      
      const variantId = addToCartBtn.id || addToCartBtn.getAttribute('id');
      
      if (!variantId) {
        console.error('Variant ID non trouvé');
        return;
      }

      let formData = {
       'items': [{
        'id': variantId,
        'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(data => {
          utils.updateCartCount(1);
          if(utils.isSpecialPromoVariant(variantId)){
            utils.showPromoPopup();
          }
          utils.showNotification();
          console.log('Produit ajouté au panier:', data);
      })
      .catch(error => {
        console.error('Erreur lors de l\'ajout au panier:', error);
      })
    });
  }

  // Initialiser lorsque le DOM est chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exporter les fonctions pour une utilisation externe si nécessaire
  window.ajaxCartCollection = {
    updateCartCount: utils.updateCartCount,
    showNotification: utils.showNotification,
    showPromoPopup: utils.showPromoPopup,
    addToCart: utils.addToCart
  };
})();